import * as React from "react";
import { ODataParams, Query } from "../../../Components/Query";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import DocumentTitle from "../../../misc/components/DocumentTitle";
import { MepAnalysisListTable } from "./MepAnalysisListTable";
import { OverreadStatusIdEnum } from "../../../misc/api/apiTypes";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";

declare var window: any;

export const MepAnalysisListScreen = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {

        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `session/visit/subject/site/studyId eq ${study.id}`;

        return await client.client.getMepAnalysisSets('id,sessionId,created,started,status,type,analyst,analystId', filter, params.orderby, 'session($select=name,visit,challengeIsClosed,overreadChallengeStatus;$expand=visit($expand=subject($expand=site)))', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="MEP Analysis Sets | Vitalograph Web Portal">
            <Query onRefresh={handleRefresh}
                initialFilters={[
                    { field: "status", condition: "eq", values: [OverreadStatusIdEnum.Pending, OverreadStatusIdEnum.NotStarted] },
                ]}
                initialOrdering={[{ field: "created", condition: "asc" }]}
            >
                <MepAnalysisListTable />
            </Query>
        </DocumentTitle>
    );
}
